<template>
  <div class="i-ellipsis-text">
    <i-tooltip v-if="text.length > charactersLength" :text="text">
      <template v-slot:tooltip-wrapper>
        <div class="preserve-spaces"><span v-if="showSlash">/ </span>
          {{ cleanedText | iEllipsis(charactersLength, characters) }}
        </div>
      </template>
    </i-tooltip>

    <div v-else>
      <div class="preserve-spaces"><span v-if="showSlash">/</span> {{ cleanedText | iEllipsis }}</div>
    </div>
  </div>
</template>

<script>
import ITooltip from "@/components/common/ITooltip.vue"

export default {
  name: "IEllipsisText",
  components: {ITooltip},
  props: {
    text: {
      type: String,
      required: true,
    },
    charactersLength: {
      type: Number,
    },
    characters: {
      type: Number,
      default: 6
    },
    showSlash: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    cleanedText() {
      return this.text.replace(/\n/g, ' ').trim();
    }
  }
}
</script>

<style lang="scss">
@import "IEllipsisText";
</style>
